import styled from '@mui/material/styles/styled'
import FormHelperText from '@mui/material/FormHelperText'

export const OptionError = styled(FormHelperText, {
  name: 'OptionError',
  slot: 'Root',
  skipSx: true,
})(({ theme }) => ({
  marginLeft: theme.spacing(4.7),
}))
